import { render, staticRenderFns } from "./ItemUpdateDialogMetaData.vue?vue&type=template&id=5b2d36aa&scoped=true"
import script from "./ItemUpdateDialogMetaData.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogMetaData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d36aa",
  null
  
)

export default component.exports